import React, { useState, useEffect } from 'react';
import { Cookies } from "../../index.js";
import { update_national_market } from "../../order/orders/actions.js";
import { useDispatch, useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";

const ProcessIP = () => {
    const dispatch = useDispatch();
    const national_market = useSelector((state) => state.national_market);

    const set_national_market = (value) => {
        dispatch(update_national_market(value));
    };

    useEffect(() => {
        const inferNationalMarket = () => {
            if (typeof navigator === "undefined") return "en";
            const langs = Array.isArray(navigator.languages) ? navigator.languages : [navigator.language];
            const normalized = langs
                .map((value) => String(value || "").toLowerCase())
                .filter(Boolean);
            return normalized.some((value) => value.startsWith("vi")) ? "vi" : "en";
        };

        const fetchWithTimeout = async (url, options = {}, timeoutMs = 1800) => {
            const controller = new AbortController();
            const timer = setTimeout(() => controller.abort(), timeoutMs);
            try {
                return await fetch(url, { ...options, signal: controller.signal });
            } finally {
                clearTimeout(timer);
            }
        };

        // Kiểm tra cookie
        function checkCookies() {
            const national = Cookies.get("national_market");
            const apikey = Cookies.get("apikey");

            const hasNational = national && national.trim().length > 0;
            const hasApikey = apikey && apikey.trim().length > 0;

            return hasNational || hasApikey;
        }

        const latestVersionRaw = String(Cookies.get("latest_version") || "").trim();
        const hostname = typeof window !== "undefined" ? String(window.location.hostname || "").toLowerCase() : "";
        const apikey = String(Cookies.get("apikey") || "").trim();
        const shouldRedirectVietnamUsers =
            latestVersionRaw === "6" &&
            hostname === "hust.media";

        const redirectToTecomPreservingPath = () => {
            if (typeof window === "undefined") return;
            const nextUrl = `https://hust.tecom.pro${window.location.pathname}${window.location.search}${window.location.hash}`;
            window.location.href = nextUrl;
        };

        // Nếu có cookie → load trực tiếp vào redux
        const existingCookie = Cookies.get("national_market");
        if (existingCookie) {
            set_national_market(existingCookie);
        }

        if (shouldRedirectVietnamUsers && apikey) {
            redirectToTecomPreservingPath();
            return;
        }

        if (checkCookies()) {
            console.log("Có cookie → không fetch IP nữa!");
            return;
        }

        let ip_address_vip = "";
        let isResolved = false;

        // Hàm lưu cookie + redux
        function setNationalMarketCookie(value) {
            if (!value) return;
            Cookies.set("national_market", value, {
                expires: 1 / 24, // 1 giờ
                path: "/",
            });
            set_national_market(value);
            isResolved = true;
            console.log("Cookie national_market đã lưu:", value);
        }

        // Fallback nhanh để tránh user phải chờ lâu khi API geo chậm.
        const fallbackTimer = setTimeout(() => {
            if (isResolved) return;
            setNationalMarketCookie(inferNationalMarket());
        }, 900);

        // 1) Lấy IP từ ipify
        fetchWithTimeout("https://api.ipify.org?format=json")
            .then((res) => res.json())
            .then((data) => {
                ip_address_vip = data.ip;
                console.log("IP ngoài cùng:", ip_address_vip);

                // 2) Check IP trong hệ thống
                return fetchWithTimeout(
                    `https://hust.media/api/sql/ip_address/check.php?ip_address_vip=${ip_address_vip}`
                );
            })
            .then((r) => r.text())
            .then((result) => {
                console.log("KQ check.php:", result);
                const normalizedResult = String(result || "").trim().toLowerCase();

                if (normalizedResult !== "") {
                    console.log("IP đã tồn tại → không gọi RapidAPI");
                    if (shouldRedirectVietnamUsers && normalizedResult === "vn") {
                        redirectToTecomPreservingPath();
                        return null;
                    }
                    setNationalMarketCookie(result);
                    return null;
                }

                // 3) IP mới → gọi RapidAPI
                console.log("IP mới → gọi RapidAPI...");
                const url = `https://ip-geo-location.p.rapidapi.com/ip/${ip_address_vip}?format=json&language=en`;

                return fetchWithTimeout(url, {
                    method: "GET",
                    headers: {
                        "x-rapidapi-host": "ip-geo-location.p.rapidapi.com",
                        "x-rapidapi-key": "a2fe20a630msh9f810747cd17d80p1fefcejsne9bdb65fb1c0",
                    },
                }, 2200);
            })
            .then((res) => (res ? res.json() : null))
            .then((data) => {
                if (!data) return;

                console.log("Data RapidAPI:", data);

                const ip_country_code = data?.country?.code || "";
                if (shouldRedirectVietnamUsers && String(ip_country_code).toUpperCase() === "VN") {
                    redirectToTecomPreservingPath();
                    return;
                }
                const deviceTypeCookie = String(Cookies.get("device_type") || "").trim();
                const device_type = deviceTypeCookie || "browser";

                // 4) Lưu main.php
                return fetchWithTimeout(
                    `https://hust.media/api/sql/ip_address/main.php?ip_address_vip=${ip_address_vip}&ip_country_code=${ip_country_code}&device_type=${encodeURIComponent(device_type)}`
                )
                    .then((r) => r.text())
                    .then((result) => {
                        console.log(result);
                        setNationalMarketCookie(result);
                    });
            })
            .catch((err) => {
                console.error("Error:", err);
                if (!isResolved) {
                    setNationalMarketCookie(inferNationalMarket());
                }
            })
            .finally(() => {
                clearTimeout(fallbackTimer);
            });
    }, []);

    // Trong component của bạn:
    const [timeoutError, setTimeoutError] = useState(false);

    // chạy 8 giây đếm
    useEffect(() => {
        if (!national_market) {
            const timer = setTimeout(() => {
                setTimeoutError(true);
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [national_market]);

    // Nếu chưa có national_market → show loader

    // --- Render ---
    if (!national_market) {
        return (
            <div className="mt-4 flex flex-col justify-center items-center text-center">

                <ClipLoader color="#fff" size={150} />

                {!timeoutError && (
                    <p className="text-green-500 text-sm mt-3 opacity-80">
                        Loading data… please wait.
                    </p>
                )}

                {timeoutError && (
                    <>
                        <p className="text-red-600 text-sm mt-3">
                            Failed to load data. The server may be responding slowly.
                        </p>

                        <button
                            onClick={() => window.location.reload()}
                            className="px-4 py-2 mt-2 rounded-lg bg-purple-600 text-white text-sm shadow hover:bg-purple-700 transition"
                        >
                            Reload Page
                        </button>
                    </>
                )}
            </div>
        );
    }
    // Nếu đã có → không render gì
    return null;
};

export default ProcessIP;
